import axios from "axios";
// const host = "https://api-idemsaude.cosmoscode.com.br";
// const host = "http://192.168.0.6:3003";
// const host = "https://api.idemsaude.com.br/scnrevolution-dev/";
const host = process.env.VUE_APP_URL_API;

let http = axios.create({
  baseURL: host,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${
      localStorage.token ? JSON.parse(localStorage.token) : ""
    }`
  }
});

http.interceptors.request.use(
  function(config) {
    config.headers.Authorization = `Bearer ${
      localStorage.token ? JSON.parse(localStorage.token) : ""
    }`;
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

export default http;
